import { gql } from 'urql';

export const getOrganizationRoles = gql`
  query GetOrganizationRoles {
    organizationRoles
  }
`;

export const getOrganization = gql`
  query GetOrganization {
    organization {
      id
      slug
      name
      lastEventAttendanceSnapshotOn
      lastEventDiffOn
      configs {
        charactersActiveCountMax
      }
    }
  }
`;

export const getOrganizationSpecialDates = gql`
  query GetOrganizationSpecialDates {
    organization {
      id
      specialDates {
        id
        title
        kind
        startsAt
        endsAt
      }
    }
  }
`;

export const getOrganizationMemberships = gql`
  query GetOrganizationMemberships($on: String) {
    organization {
      id
      memberships(on: $on) {
        id
        createdAt
        user {
          id
          fullName
          userOrganization {
            id
            role
          }
        }
        grantor {
          id
          fullName
        }
        grantingBranch {
          id
          shorthand
        }
      }
    }
  }
`;

export const getOrganizationFellowships = gql`
  query GetOrganizationFellowships($type: FellowshipKindEnum!, $activeOnly: Boolean) {
    organization {
      id
      fellowships(kind: $type, activeOnly: $activeOnly) {
        id
        name
        maxRank
        rankNames
        groupIdentifier
        charactersCount
        removedAt
        branch {
          id
          name
          shorthand
        }
        constraint {
          faiths {
            id
            level
          }
          reputations {
            id
            level
          }
          skills {
            id
            level
          }
          societies {
            id
            level
          }
        }
        fellowshipRuleTags {
          id
          ruleTag {
            id
            name
            value
          }
        }
      }
    }
  }
`;

export const getOrganizationFellowshipDetails = gql`
  query GetOrganizationFellowshipDetails($fellowshipId: Int!) {
    organization {
      id
      fellowship(fellowshipId: $fellowshipId) {
        id
        name
        kind
        maxRank
        rankNames
        description
        charactersCount
        removedAt
        branch {
          id
          name
          shorthand
        }
        characterFellowships {
          id
          rank
          removedAt
          character {
            id
            name
            user {
              id
              fullName
              userOrganization {
                id
                branch {
                  id
                  shorthand
                }
              }
            }
          }
        }
        constraint {
          faiths {
            id
            level
          }
          reputations {
            id
            level
          }
          skills {
            id
            level
          }
          societies {
            id
            level
          }
        }
        fellowshipRuleTags {
          id
          ruleTag {
            id
            name
            value
          }
        }
      }
    }
  }
`;

export const getOrganizationRebirthedCharacters = gql`
  query GetOrganizationRebirthedCharacters {
    organization {
      id
      rebirthedCharacters {
        id
        name
        legacyHomeGameCount
        createdAt
        user {
          id
          fullName
          userOrganization {
            id
            branch {
              id
              name
              shorthand
            }
          }
        }
        retiredCharacter {
          id
          name
        }
      }
    }
  }
`;

export const getOrganizationRuleTags = gql`
  query GetOrganizationRuleTags {
    organization {
      id
      ruleTags {
        id
        name
        value
      }
    }
  }
`;

export const getOrganizationStatistics = gql`
  query GetOrganizationStatistics(
    $type: StatisticsTypeEnum!
    $eventId: Int
    $branchIds: [Int!]
    $printRequested: Boolean
    $isPaid: Boolean
    $isLocal: Boolean
  ) {
    organization {
      id
      statistics(
        type: $type
        eventId: $eventId
        branchIds: $branchIds
        printRequested: $printRequested
        isPaid: $isPaid
        isLocal: $isLocal
      ) {
        ... on SkillsStatistics {
          eventId
          type
          values {
            id
            level
            count
          }
        }
        ... on SkillCategoriesStatistics {
          eventId
          type
          values {
            aberrants {
              id
              name
              user {
                id
                fullName
              }
            }
            criminals {
              id
              name
              user {
                id
                fullName
              }
            }
            total
          }
        }
        ... on ResidenciesStatistics {
          eventId
          type
          values {
            id
            shorthand
            name
            count
          }
        }
        ... on StatsStatistics {
          eventId
          type
          values {
            body
            mind
            resolve
            currentLife
            buildUsed
            buildEarned
            faithId
          }
        }
      }
    }
  }
`;

export const getOrganizationCharacters = gql`
  query GetOrganizationCharacters(
    $eventId: Int
    $branchIds: [Int!]
    $printRequested: Boolean
    $idPaid: Boolean
    $isLocal: Boolean
    $skillIds: [Int!]
    $reputationIds: [Int!]
    $loreIds: [Int!]
    $level: Int
    $currentLife: [Int!]
    $currentResolve: [Int!]
    $currentBody: [Int!]
    $currentMind: [Int!]
    $buildEarned: [Int!]
  ) {
    organization {
      id
      characters(
        eventId: $eventId
        branchIds: $branchIds
        printRequested: $printRequested
        isPaid: $idPaid
        isLocal: $isLocal
        skillIds: $skillIds
        reputationIds: $reputationIds
        loreIds: $loreIds
        level: $level
        currentLife: $currentLife
        currentResolve: $currentResolve
        currentBody: $currentBody
        currentMind: $currentMind
        buildEarned: $buildEarned
      ) {
        id
        name
        user {
          id
          fullName
        }
      }
    }
  }
`;

export const getOrganizationTimelines = gql`
  query GetOrganizationTimelines {
    organization {
      id
      timelines {
        id
        shorthand
        eventId
        eventName
        local
        virtual
        timecode
        attendance
      }
    }
  }
`;

export const getOrganizationArmorUpgradeComponents = gql`
  query GetOrganizationArmorUpgradeComponents {
    organization {
      id
      armorUpgradeComponents {
        amount
        component {
          id
          name
          kind
        }
      }
    }
  }
`;
